import { z } from 'zod';
/**
 * Đối chứng gọi thẳng model — APM-H-s. Cùng skill, cùng đầu vào, nhưng **một
 * lời gọi**: system prompt của skill (bản ghi đè nếu có) + message người dùng,
 * ép hình dạng bằng schema, **không tool, không hook, không kiến thức, không hồ
 * sơ, không bộ nhớ, không verify lặp**. Đặt cạnh run harness để trả lời câu
 * "harness đáng cái giá của nó không" bằng số: hợp lệ, có căn cứ, chi phí, độ trễ.
 */
export const DirectCallInput = z.object({
    skill: z.string().min(1).max(60),
    projectId: z.uuid(),
    prompt: z.string().min(1).max(10_000),
    params: z.record(z.string(), z.unknown()).optional(),
});
export const DirectCallResult = z.object({
    skill: z.string(),
    modelId: z.string(),
    /** Output qua Zod của skill; `null` khi model trả sai hình dạng (không có lượt sửa). */
    output: z.unknown().nullable(),
    valid: z.boolean(),
    /**
     * Model chạm trần token đầu ra giữa chừng (`stop_reason: max_tokens`) — câu
     * trả lời bị cắt, nên `valid: false` ở đây **không** nói gì về khả năng của
     * model. Đo thật 2026-09-15: `generate_plan` gọi thẳng trả đúng 16.000 token
     * rồi đứt, JSON dở dang, Zod báo thiếu trường.
     */
    truncated: z.boolean(),
    issues: z.array(z.object({ path: z.string(), message: z.string() })),
    /** Id/biên nhận không có căn cứ — với gọi thẳng, căn cứ chỉ là message và params (không có tool). */
    ungrounded: z.array(z.object({ path: z.string(), value: z.string(), reason: z.string() })),
    /** `finalize()` của skill loại gì (nếu skill có) — không có lượt sửa nên chỉ ghi nhận. */
    rejected: z.array(z.object({ path: z.string(), reason: z.string() })),
    costUsd: z.string(),
    latencyMs: z.number().int().nonnegative(),
    usage: z.object({
        inputTokens: z.number().int().nonnegative(),
        outputTokens: z.number().int().nonnegative(),
        cacheReadInputTokens: z.number().int().nonnegative(),
        cacheCreationInputTokens: z.number().int().nonnegative(),
    }),
    usageLogId: z.string(),
    /** Text thô model trả, cắt 4 000 ký tự — để đọc khi `valid = false`. */
    rawText: z.string(),
    promptVersion: z.string().nullable(),
});
//# sourceMappingURL=ai-direct.js.map